import { render, staticRenderFns } from "./CanopyCalculator.vue?vue&type=template&id=65ed45bd&"
import script from "./CanopyCalculator.vue?vue&type=script&lang=js&"
export * from "./CanopyCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports